import { init, RematchDispatch, RematchRootState } from "@rematch/core";
import createRematchPersist from "@rematch/persist";
import storage from "redux-persist/lib/storage";
import {
  betBuilderMiddleware,
  updateLocalStorageBetSlipsMiddleware,
  validateBetBuilderMiddleware,
} from "./middleware";
import * as models from "./models/models";

type RootModel = typeof models;

const persistPlugin = createRematchPersist({
  key: "root",
  whitelist: [
    "betSlipListModel",
    "multiplesBetSlipListModel",
    "cashierModel",
    "competitionsListFiltersModel", // I think this can be removed, but need to check it thoroughly for edge casesfirst
    "betBuilderModel",
    "navigationModel",
  ],
  throttle: 500,
  version: 1,
  storage,
}) as any;

const store = init<RootModel>({
  models,
  plugins: [persistPlugin],
  redux: {
    middlewares: [
      betBuilderMiddleware,
      validateBetBuilderMiddleware,
      updateLocalStorageBetSlipsMiddleware,
    ],
  },
  name: "3ET-UI",
});

export default store;

export type RootState = RematchRootState<any>;
export type RootDispatch = RematchDispatch<any>;
